export default "__VITE_ASSET__CgpmghMT__"